import fetchBase from "./fetch-base";

async function GET<T>(url: string, options: RequestInit = {}) {
  return fetchBase<T>(url, null, options);
}

export default GET;
